import { render, staticRenderFns } from "./ImportStatusBadge.vue?vue&type=template&id=2d7ada09&"
import script from "./ImportStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ImportStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports